import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseMessageComponent } from './base-message.component';
import { DefaultTableSelectionHandler, TABLE_SELECTOR_HANDLER } from '@cbre/components';

@Component({
  selector: 'miq-table',
  template: `
    <p class="summary">{{ summary }}</p>

    <div class="table-container">
      <cbre-table
        [elements]="rowData"
        [columns]="columns"
        [pageSize]="10"
        [pageSizeOptions]="[10, 20, 50, 100]"
        maxHeight="600px"
        [stickyHeader]="true"
      ></cbre-table>
    </div>
  `,
  styles: [
    `
      .summary {
        font-size: 14px;
        margin-bottom: 10px;
      }
      .table-container ::ng-deep.mat-mdc-paginator-container {
        flex-wrap: nowrap !important;
        .mat-mdc-paginator-range-label {
          margin-right: 0 !important;
          margin-left: 17px !important;
        }
      }
    `,
  ],
  providers: [{ provide: TABLE_SELECTOR_HANDLER, useClass: DefaultTableSelectionHandler }],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChatTableComponent implements BaseMessageComponent {
  private _content: Record<string, any>;

  @Input()
  set content(value: Record<string, any>) {
    this._content = value;
    if (this._content) {
      this.summary = this._content.summary || '';
      if (this._content.columns && this._content.rows?.length > 0) {
        // Use provided headers (columns) to build column definitions
        this.columns = this._buildColumns(this._content.columns);

        // Map rows (array of values) to objects using the headers
        this.rowData = this._content.rows.map(row =>
          this._content.columns.reduce((acc: Record<string, any>, key: string, index: number) => {
            acc[key] = row[index];
            return acc;
          }, {})
        );
      } else {
        this.columns = [];
        this.rowData = [];
      }
    }
  }

  columns: Record<string, any>[] = [];
  rowData: Record<string, any>[] = [];
  summary = '';

  private _buildColumns(keys: string[]): Record<string, any>[] {
    return keys.map(key => ({
      field: key,
      header: this.formatHeader(key),
    }));
  }

  private formatHeader(key: string): string {
    // Convert keys like 'AREA_LEASED' to 'Area Leased'
    return key
      .toLowerCase()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, char => char.toUpperCase());
  }
}
